import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loader from '../utils/Loader';
import { setStatFilters } from '../../action/statistics';
import { isEmpty } from 'lodash';
import Select from 'react-select';
import { categoriesRawByType } from '../../selectors/raw';
import { fetchProductCategories } from '../../action/raw';
import ReactPaginate from 'react-paginate';
import moment from 'moment';
import { getBalanceRaws } from '../../action/recipes';
import { fetchFilials } from '../../action/handbook';
import { fetchGoods } from '../../action';
import { MEASURES_RAW } from '../../containers/rawmaterials/constansts';
import { fetchSettings } from '../../action/app';
import swal from "sweetalert";
import {utils, writeFileXLSX} from "xlsx";
import SortButton from '../utils/SortButton';
import { formatNumberWithSpaces, parseNumToFixed } from '../../utils/common';
import DateSelect from '../utils/DateSelect';

const styles = {
    loading: {
        minHeight: '200px',
        display: 'flex',
        justifyContent: 'center'
    }
}

class MovementRaws extends Component {
    state = {
        currentPage: 0,
        data: null,
        count: 0,
        loadingData: false,
        error: null,
    }

    DateInputRef = React.createRef();
    
    onChangeDateSelect = (e) => {
        const { filters } = this.props.movementRaws;

        if (e && e.min && e.max) {
            const updated = { ...filters};
            updated.date_gt = e.min;
            updated.date_lte = e.max;
            this.props.setStatFilters('movementRaws', updated);
        }
    }

    onExport = async () => {
        const { filters } = this.props.movementRaws;
        const params = filters;
        params._start = 0;
        params._limit = -1;
        const result = await this.props.getBalanceRaws(filters);
        const point = this.props.filials.find((item) => item.id === filters.point);
        const pointLabel = this.renderPointLabel(point);
        const exportData = result.data.flatMap((raw) => {
            return {
                'Наименование': raw.name,
                'Ед. измерения': MEASURES_RAW[raw.measure],
                'Приход': parseNumToFixed(raw.coming, 3),
                'Расход': parseNumToFixed(raw.expenditure, 3),
                'Списания': parseNumToFixed(raw.writeoff, 3),
            }
        });
        const ws = utils.json_to_sheet(exportData);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, "Движение сырья");
        writeFileXLSX(wb, `Движение сырья ${pointLabel} с ${moment(filters.date_gt).format('DD-MM-YYYY')} по ${moment(filters.date_lte).format('DD-MM-YYYY')}.xlsx`);
    }

    onSearch = async (newParams = null) => {
        const { filters } = this.props.movementRaws;
        this.setState({ loadingData: true });
        const params = newParams ? newParams : filters;
        const result = await this.props.getBalanceRaws(params);
        if (result && result.error) return this.setState({ error: result.error.data, loadingData: false });
        if (result) this.setState({ data: result.data, count: result.count, loadingData: false, error: null });
    }

    componentDidMount() {
        if (isEmpty(this.props.productCategories)) this.props.fetchProductCategories();
        if (isEmpty(this.props.filials)) this.props.fetchFilials();
        if (isEmpty(this.props.goods)) this.props.fetchGoods();
        if (isEmpty(this.props.settings)) this.props.fetchSettings();
    }

    onChangeDateInput = (field) => (date) => {
        const { filters } = this.props.movementRaws;
        const updated = { ...filters, [field]: date };
        if (field === 'date_gt') updated.date_lte = moment(date).add({ days: 30 }).toDate()
        this.props.setStatFilters('movementRaws', updated);
    }

    onChangeSelect = (e, field) => {
        const { filters } = this.props.movementRaws;
        if (field === 'point' && e && !e.enableConsumption) { 
            const updated = { ...filters, [field]: null };
            this.props.setStatFilters('movementRaws', updated);
            return swal({
                title: `Получение данных о ${e.label} невозможно`,
                text: '"Списание сырья" отключено',
                icon: "error",
                dangerMode: true,
                button: "Ок",
            });
        }
        const updated = { ...filters, [field]: e.value };
        this.props.setStatFilters('movementRaws', updated);
    }

    renderPointLabel = (point) => {
        if (!point) return '';
        return `${point.city.name}, ${point.street || 'Улица не указана'} ${point.house || ''}`
    }

    pointOptions = () => {
        const options = [
            ...this.props.filials.map(el => ({
                value: el.id,
                label: this.renderPointLabel(el),
                enableConsumption: el.enableConsumption,
            })).sort((a, b) => {
                if (a.label < b.label) return -1;
                if (a.label > b.label) return 1;
                return 0;
            })
        ]
        return options;
    }

    categoryOptions = () => {
        const options = [
            {value: null, label: 'Все категории'},
            ...this.props.productCategories.map(el => ({
                value: el.id,
                label: el.title,
            })).sort((a, b) => {
                if (a.label < b.label) return -1;
                if (a.label > b.label) return 1;
                return 0;
            })
        ]
        return options;
    }

    renderHead() {
        const { filters } = this.props.movementRaws;
        const disabledConsumption = !isEmpty(this.props.settings) && !this.props.settings.enableConsumption;
        

        return(
            <div className="kt-portlet__head" style={{ flexDirection: 'column', gap: '10px' }}>
                <div className="kt-portlet__head-label">
                    <h3 className="kt-portlet__head-title">
                        Движение сырья
                    </h3>
                </div>
                <div className="kt-portlet__head-toolbar" style={{ alignItems: 'start', gap: '10px' }}>
                <div style={{ width: 200 }}>
                    <DateSelect
                        isLoading={this.props.loadingFilials}
                        isDisabled={ this.props.loadingFilials || disabledConsumption}
                        optionsDate={{
                            tommorow: true,
                            period: true,
                            prevWeek: true,
                            prevMonth: true,
                            noYear: true,
                        }}
                        limit={{ 
                            field: 'days',
                            value: 31
                        }}
                        width={200}
                        onChange={this.onChangeDateSelect}
                    />
                    </div>
                    <div style={{ width: 200 }}>
                        <Select
                            isLoading={this.props.loadingFilials}
                            isDisabled={this.props.loadingFilials || disabledConsumption}
                            value={filters.point ? this.pointOptions().find((point) => point.id === filters.point) : null}
                            placeholder='Филиал'e
                            onChange={(e) => this.onChangeSelect(e, 'point')}
                            options={this.pointOptions()}
                        />
                    </div>
                    <div style={{ width: 200 }}>
                        <Select
                            isLoading={this.props.loadingFilials}
                            isDisabled={this.props.loadingFilials || disabledConsumption}
                            value={filters.category ? this.categoryOptions().find((category) => category.id === filters.category) : null}
                            placeholder='Категория'
                            onChange={(e) => this.onChangeSelect(e, 'category')}
                            options={this.categoryOptions()}
                        />
                    </div>
                    <button disabled={!filters.point || disabledConsumption} className='btn btn-primary' onClick={() => this.onSearch()}> Найти </button>
                    <button disabled={!filters.point || disabledConsumption} className='btn btn-success' onClick={this.onExport}> Экспорт </button>
                </div>
            </div>
        );
    }

    handlePageClick = (data) => {
        const { filters } = this.props.movementRaws;
        this.setState({ currentPage: data.selected });
        let nextStart = data.selected * filters._limit;
        const updated = { ...filters, _start: nextStart, };
        this.props.setStatFilters('movementRaws', updated);
        this.onSearch(updated);
    };

    setPageLimit = (e) => {
        e.preventDefault();
        const { filters } = this.props.movementRaws;
        let _limit = parseInt(e.target.value, 10);
        if (Number.isNaN(_limit) || _limit <= 0) {
            _limit = 10;
        }
        const updated = { ...filters, _start: 0, _limit };
        this.setState({ currentPage: 0 });
        this.props.setStatFilters('movementRaws', updated);
        this.onSearch(updated);
    }

    chekMarginPagesDisplayed() {
        const userDisplayWidth = window.innerWidth;
        if (userDisplayWidth < 400) return 1;
        if (userDisplayWidth < 550) return 2;
        if (userDisplayWidth < 850) return 3;
        if (userDisplayWidth < 1250) return 5;
        return 8;
    }

    chekPageRangeDisplayed() {
        const userDisplayWidth = window.innerWidth;
        if(userDisplayWidth < 550) return 2;
        if(userDisplayWidth < 850) return 3;
        return 5;
    }

    renderPagination() {
        const { filters } = this.props.movementRaws;
        const pages = Math.ceil(+this.state.count / +filters._limit);
        if (!this.state.data) return;

        return (
            <div className="kt-datatable__pager kt-datatable--paging-loaded order_table">
                <ReactPaginate
                    previousLabel={<i className="flaticon2-back"></i>}
                    nextLabel={<i className="flaticon2-next"></i>}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={pages}
                    marginPagesDisplayed={this.chekMarginPagesDisplayed()}
                    pageRangeDisplayed={this.chekPageRangeDisplayed()}
                    forcePage={this.state.currentPage}
                    onPageChange={this.handlePageClick}
                    containerClassName={'kt-datatable__pager-nav'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                    pageLinkClassName="kt-datatable__pager-link kt-datatable__pager-link-number"
                    previousLinkClassName="kt-datatable__pager-link kt-datatable__pager-link--prev"
                    nextLinkClassName="kt-datatable__pager-link kt-datatable__pager-link--next"
                    activeLinkClassName="kt-datatable__pager-link--active"
                    disabledClassName="kt-datatable__pager-link--disabled"
                />

                    <div className="kt-datatable__pager-info">
                        <div className="kt-datatable__pager-size">
                            <select onChange={this.setPageLimit} value={filters._limit} className="form-control">
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="30">30</option>
                            </select>
                            
                        </div>                        
                        {
                            filters._start + filters._limit >= this.state.count ? (
                                <span className="kt-datatable__pager-detail">Показано {filters._start + 1} - {+this.state.count} из {this.state.count}</span>
                            ) : (
                                <span className="kt-datatable__pager-detail">Показано {filters._start + 1} - {+filters._start + +filters._limit} из {this.state.count}</span>
                            )
                        }
                       
                    </div>
            </div>
    
        );
    }

    handleClickSort(newFiled) {
        const { filters } = this.props.movementRaws;
        const updated = { ...filters };
        const { _sort } = updated;
        const [ field, sort ] = _sort.split(':');

        if (newFiled === field) {
            const newSort = sort === 'DESC' ? 'ASC' : 'DESC';
            updated._sort = `${field}:${newSort}`;
        } else {
            updated._sort = `${newFiled}:ASC`;
        }

        this.props.setStatFilters('movementRaws', updated);
        this.onSearch(updated);
    }

    renderBody() {
        const { loading } = this.props.movementRaws;
        const { data, loadingData } = this.state;
        const { loadingGoods, settings } = this.props;
        const disabledConsumption = !isEmpty(settings) && !settings.enableConsumption;

        if (loading || loadingGoods || loadingData) return <div style={styles.loading}><Loader /></div>;

        if (disabledConsumption) return (
            <div className="kt-portlet">
                <div className='kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid' style={{ padding: '0px' }}>
                    <div className='kt-portlet kt-portlet--mobile'>
                        <div className='kt-portlet__body kt-portlet__body--fit'>
                            <div style={this.props.style} className='alert fade show alert-outline-danger'>
                                    <div className="alert-icon"><i className="flaticon-warning"></i></div>
                                    <div className="alert-text">{`"Списание сырья" отключено`}</div>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        )
        
        const { filters } = this.props.movementRaws;
        const { _sort } = filters;
        const [ field, sort ] = _sort.split(':');

        return(
            <>
            <div className="kt-portlet">
                <div className='kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid' style={{ padding: '0px' }}>
                    <div className='kt-portlet kt-portlet--mobile'>
                        <div className='kt-portlet__body kt-portlet__body--fit'> 
                            {this.state.error && 
                                <div style={this.props.style} className='alert fade show alert-outline-danger'>
                                    <div className="alert-icon"><i className="flaticon-warning"></i></div>
                                    <div className="alert-text">{`Ошибка ${this.state.error.statusCode} ${this.state.error.message}`}</div>
                                </div>
                            }
                            <div className='kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded'>
                                <table className='kt-datatable__table'>
                                    {data && <thead className='kt-datatable__head'>
                                        <tr className='kt-datatable__row'>
                                            <th className='kt-datatable__cell good_id'><SortButton className={field === 'id' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} text='ID' onClick={() => this.handleClickSort('id')} up={field === 'id' && sort === 'ASC'}/></th>
                                            <th className='kt-datatable__cell' style={{ width: '165px' }}><SortButton className={field === 'name' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} text='Наименование' onClick={() => this.handleClickSort('name')} up={field === 'name' && sort === 'ASC'}/></th>
                                            <th className='kt-datatable__cell' style={{ width: 'auto' }}></th>
                                            <th className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}><span>Приход</span></th>
                                            <th className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}><span>Расход</span></th>
                                            <th className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}><span>Списания</span></th>
                                        </tr>
                                    </thead>}
                                    <tbody className='kt-datatable__body'>
                                        {!data
                                        ? <tr className='kt-datatable__row'>Нет данных</tr> 
                                        : data.map((raw) => {
                                            return (
                                                <>
                                                    <tr className='kt-datatable__row'>
                                                        <td className='kt-datatable__cell good_id'>{raw.id || ''}</td>
                                                        <td className='kt-datatable__cell' style={{ width: '165px' }}><span>{raw.name}</span></td>
                                                        <td className='kt-datatable__cell' style={{ width: 'auto' }}>{MEASURES_RAW[raw.measure]}</td>
                                                        <td className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}><span>{formatNumberWithSpaces(parseNumToFixed(raw.coming, 3))}</span></td>
                                                        <td className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}><span>{formatNumberWithSpaces(parseNumToFixed(raw.expenditure, 3))}</span></td>
                                                        <td className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}><span>{formatNumberWithSpaces(parseNumToFixed(raw.writeoff, 3))}</span></td>
                                                    </tr>
                                                </>
                                            );
                                        })
                                        }
                                    </tbody>
                                </table>
                                {this.renderPagination()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </>
        )
    }

    render() {
        return (
            <>
                <div className="kt-portlet">
                    {this.renderHead()}
                </div>
                {this.renderBody()}
            </>
        );
    }
}

const mapStateToProps = state => {
    return ({
        productCategories: categoriesRawByType('raw')(state),
        movementRaws: state.statistics.movementRaws,
        loadingFilials: state.loaders.filials,
        filials: state.handbook.filials,
        goods: state.good.list,
        settings: state.settings.init,
    });
};

const mapDispatchToProps = {
    fetchProductCategories: () => fetchProductCategories('raw'),
    setStatFilters: (name, filters) => setStatFilters(name, filters),
    fetchFilials: () => fetchFilials(null, true),
    getBalanceRaws: (filters) => getBalanceRaws(filters),
    fetchGoods: () => fetchGoods(),
    fetchSettings: () => fetchSettings(),
}

export default connect(mapStateToProps, mapDispatchToProps)(MovementRaws);